import { cloneElement, CSSProperties, ReactElement } from 'react';
import { ICellRendererParams } from 'ag-grid-community';

interface GridCustomDisplayProps extends ICellRendererParams {
    component: ReactElement;
    containerStyle?: CSSProperties;
    dataId?: string;
}

export const GridCustomDisplayView = ({ value, data, api, component, containerStyle, dataId }: GridCustomDisplayProps) => {
    return (
        <div style={containerStyle} data-test-id={dataId}>
            {cloneElement(component, {
                value,
                data,
                api
            })}
        </div>
    );
};
